import { render, staticRenderFns } from "./MaintenanceRatings.vue?vue&type=template&id=6283bb64&scoped=true&"
import script from "./MaintenanceRatings.vue?vue&type=script&lang=js&"
export * from "./MaintenanceRatings.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceRatings.vue?vue&type=style&index=0&id=6283bb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283bb64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
